import { userTypes } from 'config/config';
import PageNotFound from 'pages/404';
import UnauthorizedPage from 'pages/UnauthorizedPage';
import { Route, Routes } from 'react-router-dom';
import AdminDashboard from 'screens/admin/AdminDashboard';
import AnalyticsScreen from 'screens/analytics/Analytics';
import ChangePassword from 'screens/password/ChangePassword';
import Preference from 'screens/preferences/Preference';

import ProtectedRoute from './ProtectedRoute';
import Layout from '../components/Layout';

const CompanyStaffRoutes = () => (
  <ProtectedRoute allowedRoles={[userTypes.companyStaff]}>
    <Layout>
      <Routes>
        <Route path="dashboard" element={<AnalyticsScreen />} />
        <Route path="documents/*" element={<AdminDashboard />} />

        {/* <Route path="preference" element={<PreferenceAdmin />} /> */}
        <Route path="preference" element={<Preference />} />
        <Route path="change-password" element={<ChangePassword />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        {/* <Route path="/contract-management" element={<ContractManagement />} /> */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Layout>
  </ProtectedRoute>
);
export default CompanyStaffRoutes;
